import { Box } from '@material-ui/core'
import { ContentBlock } from '../components'
import InsuranceCards from '../MemberCard/InsuranceCards'

interface FinalInsuranceValidatingCardUploadProps {
  order: APIResponse.DME.Order
}

export default function FinalInsuranceValidatingCardUpload({
  order,
}: FinalInsuranceValidatingCardUploadProps) {
  return (
    <ContentBlock title="Insurance next steps" variant="warn">
      <Box mb={2}>
        During our final insurance check, your insurance was flagged as needing
        a manual review. This could be because something has changed in your
        policy.
      </Box>
      <Box mb={2}>
        We need some help from you to verify your insurance. Please upload a
        front and back image of your insurance card below.
      </Box>
      Once verified, your order will be sent to our warehouse for shipping. If
      there are concerns with your insurance, we will email directly.
      <InsuranceCards order={order} />
    </ContentBlock>
  )
}
